<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
  
      row-key="UserId"
      ref="list"
      unit="产品加工流程"
      :page="page"
      :show-query="true"
      :get-data-func="api.proList" 
      :query-params="params"
      v-if="trendShow"
      urlHash="production/craftsmanship/process"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";



export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/production/teProduct").default,

      productApi: require('@/api/ba/product').default,
      trendShow: true,
      params: {
        ProductName: "",
        Number: "",
      },
    };
  },
  mounted(){
     
  },
  methods: {
    
  }
};
</script>
